import React, { useState, useCallback } from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import { Tooltip, Dialog } from '@mui/material';
import { InsertPhoto, CloudUpload } from '@mui/icons-material';
import { TextField } from '@totalsoft/rocket-ui';
import { SpanWithPictureAction, DialogContentWithImgModalContent, ImgWithModalImg } from '../styles/style';

function DealerBrandingImageTextField({ name, label, value, hasLogo, imageSource, alt, onUploadClick }) {
  const [t] = useTranslation();

  const [showModal, setShowModal] = useState(false);

  const onToggleModal = useCallback(show => setShowModal(show), []);

  return (
    <>
      <TextField
        disabled
        fullWidth
        name={name}
        value={value || ''}
        label={label}
        endAdornment={
          <>
            {hasLogo && (
              <Tooltip title={t('Branding.DisplayLogoPicture')}>
                <SpanWithPictureAction onClick={() => onToggleModal(true)}>
                  <InsertPhoto color={'primary'} />
                </SpanWithPictureAction>
              </Tooltip>
            )}
            <Tooltip title={t('Branding.ChooseLogoPicture')}>
              <SpanWithPictureAction onClick={onUploadClick}>
                <CloudUpload color={'primary'} />
              </SpanWithPictureAction>
            </Tooltip>
          </>
        }
      />
      {showModal && (
        <Dialog open maxWidth={false} onClose={() => onToggleModal(false)}>
          <DialogContentWithImgModalContent>
            <ImgWithModalImg src={imageSource} alt={alt} />
          </DialogContentWithImgModalContent>
        </Dialog>
      )}
    </>
  );
}

DealerBrandingImageTextField.propTypes = {
  name: PropTypes.string.isRequired,
  label: PropTypes.string,
  value: PropTypes.string,
  hasLogo: PropTypes.bool,
  imageSource: PropTypes.string,
  alt: PropTypes.string.isRequired,
  onUploadClick: PropTypes.func.isRequired
};

export default DealerBrandingImageTextField;
